/**
 * Colores recomendados para mostrar cuando no hay colores recientes
 */
export const RECOMMENDED_COLORS = [
  '#000000', // Negro
  '#FFFFFF', // Blanco
  '#FF0000', // Rojo
  '#00FF00', // Verde
  '#0000FF', // Azul
  '#FFFF00', // Amarillo
  '#FF00FF', // Magenta
  '#00FFFF', // Cyan
  '#FFA500', // Naranja
  '#800080', // Púrpura
  '#FFC0CB', // Rosa
  '#A52A2A', // Marrón
  '#808080', // Gris
  '#000080', // Azul marino
  '#008000', // Verde oscuro
  '#FFD700', // Dorado
  '#C0C0C0', // Plata
  '#FF6347', // Tomate
  '#40E0D0', // Turquesa
  '#EE82EE', // Violeta
];

/**
 * Clave para almacenar colores recientes en localStorage
 */
export const STORAGE_KEY = 'color-picker-recent';
